import type { ValueOf } from './util/typeUtils';

export const TEMPLATE_TYPES = {
    DIVISION_FOOTER: 'DIVISION_FOOTER',
    DIVISION_HEADER: 'DIVISION_HEADER',
    DIVISION_MAIL: 'DIVISION_MAIL',
    MAIL: 'MAIL',
    MAIL_FOOTER: 'MAIL_FOOTER',
    MAIL_HEADER: 'MAIL_HEADER',
    MAIL_SIGNATURE: 'MAIL_SIGNATURE',
    OFFER_MAIL: 'OFFER_MAIL',
    SYSTEM_MAIL: 'SYSTEM_MAIL',
} as const;

export type TEMPLATE_TYPE = ValueOf<typeof TEMPLATE_TYPES>;

export const DIVISION_HEADER_FOOTER_TYPES = [TEMPLATE_TYPES.DIVISION_HEADER, TEMPLATE_TYPES.DIVISION_FOOTER] as const;

export type DIVISION_HEADER_FOOTER_TYPE = (typeof DIVISION_HEADER_FOOTER_TYPES)[number];

export const MAIL_HEADER_FOOTER_PARTS = {
    FOOTER: 'footer',
    HEADER: 'header',
} as const;

export type MAIL_HEADER_FOOTER_PART = ValueOf<typeof MAIL_HEADER_FOOTER_PARTS>;

export const DIVISION_TEMPLATE_ID_NAMESPACE = '642c0a35-5b08-4722-ac6e-0e624f02dc5c';

export const DIVISION_TEMPLATE_ERRORS = {
    STATUS_ALREADY_ASSIGNED: 'STATUS_ALREADY_ASSIGNED',
};

export const MAIL_TYPES = {
    SYSTEM_MAIL: 'SYSTEM_MAIL',
    USER_MAIL: 'USER_MAIL',
} as const;

export type MAIL_TYPE = ValueOf<typeof MAIL_TYPES>;

export const MAIL_CATEGORIES = {
    ADVERTISEMENT_CONSENT_MAIL: 'ADVERTISEMENT_CONSENT_MAIL',
    ADVERTISEMENT_CONSENT_MAIL_WITH_INFO: 'ADVERTISEMENT_CONSENT_MAIL_WITH_INFO',
    CANCELLATION_MAIL: 'CANCELLATION_MAIL',
    CO_VERIFICATION_MAIL: 'CO_VERIFICATION_MAIL',
    DATA_CONSENT_MAIL: 'DATA_CONSENT_MAIL',
    DIVISION_MAIL: 'DIVISION_MAIL',
    DOCUMENT_DEMAND_MAIL: 'DOCUMENT_DEMAND_MAIL',
    DOCUMENT_DEMAND_REMIND_MAIL: 'DOCUMENT_DEMAND_REMIND_MAIL',
    INFO_MAIL: 'INFO_MAIL',
    VERIFICATION_MAIL: 'VERIFICATION_MAIL',
} as const;

export type MAIL_CATEGORY = ValueOf<typeof MAIL_CATEGORIES>;

export const USER_MAIL_CATEGORIES = {
    PASSWORD_RESET_MAIL: 'PASSWORD_RESET_MAIL',
    REGISTRATION_MAIL: 'REGISTRATION_MAIL',
    SECRET_RESET_MAIL: 'SECRET_RESET_MAIL',
} as const;
export type USER_MAIL_CATEGORY = ValueOf<typeof USER_MAIL_CATEGORIES>;

export const MAIL_ROUTES = {
    DIVISION: '/management/templates/division/',
    DIVISION_ID: '/management/templates/division/$templateId',
    DIVISIONS: '/management/templates/divisions/',
    DIVISIONS_ID: '/management/templates/divisions/$templateId',
    GENERAL: '/management/templates/general/',
    GENERAL_ID: '/management/templates/general/$templateId',
} as const;
